var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"report_detail"},[_c('table',[_c('thead',[_c('tr',_vm._l((50),function(n,i){return _c('th',[_vm._v("字段 "+_vm._s(i+1))])}),0)]),_c('tbody',_vm._l((100),function(n,i){return _c('tr',_vm._l((50),function(m,j){return _c('td',[_vm._v(_vm._s(j+1))])}),0)}),0)])])
}
var staticRenderFns = []

export { render, staticRenderFns }